import { useFilter } from "hooks/filter";
import { Chip, Typography, Box, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ActiveFilters() {
  const { searchState, searchDispatch } = useFilter();
  return (
    <>
      {searchState.activeFilters.length > 0 && (
        <Box mt={2}>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={1}
            wrap="wrap"
          >
            {searchState.activeFilters.map((filter, index) => {
              return (
                <Grid item alignItems="flex-start" key={index}>
                  <Chip
                    variant="outlined"
                    color="primary"
                    size="small"
                    label={
                      <Typography variant="caption">
                        {filter.label}: {filter.labelValue}
                      </Typography>
                    }
                    onDelete={() =>
                      searchDispatch({
                        type: "REMOVE_FILTER",
                        payload: {
                          criteria: filter.searchCriteria,
                          propertyCriteria: filter.propertyCriteria,
                          value: filter.value,
                        },
                      })
                    }
                  />
                </Grid>
              );
            })}
            {searchState.activeFilters.length > 1 && (
              <Grid item>
                <Chip
                  variant="outlined"
                  color="primary"
                  icon={<DeleteIcon />}
                  size="small"
                  label={
                    <Typography variant="caption">Clear filters</Typography>
                  }
                  onClick={() => searchDispatch({ type: "REMOVE_ALL_FILTER" })}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </>
  );
}
